import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';
import { CertificadoRecebiveisApiResponse } from 'common/genericTypes';
import {
  tipoProRataDescriptions,
  indexadorRemuneracaoDescriptions,
  periodicidadeCorrecaoDescriptions,
  tipoProjecaoDescriptions,
  convencaoJurosFixosDescriptions,
  inicioRentabilidadeDescriptions,
} from 'common/genericDescriptions';
import moment from 'moment';
import { addCpfCnpjMask } from 'utils/mask';
import { formatEightDecimalsNumber } from 'utils/number';
import MultaMoraDetailsSection from 'components/instrumentos/registro/criteriosRemuneracao/sections/MultaMoraSection/MultaMoraDetailsSection';

interface Props {
  certificadoRecebiveis: CertificadoRecebiveisApiResponse;
}

export const DetalhesCriteriosRemuneracao: React.FC<Props> = ({ certificadoRecebiveis }) => (
  <>
    <Section title={'Informações Financeiras'} defaultGrid>
      <div>
        <Typography variant="body2">{'Vol. Nominal Un. de Emissão:'}</Typography>
        <Typography variant="body1">
          {formatEightDecimalsNumber(certificadoRecebiveis.criteriosRemuneracao.valorNominalUnitarioEmissao)}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Quantidade Emitida:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.criteriosRemuneracao.quantidadeEmitida}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Vol. de Emissão:'}</Typography>
        <Typography variant="body1">
          {certificadoRecebiveis.criteriosRemuneracao.volumeEmissao.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Moeda de Emissão:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.criteriosRemuneracao.moedaEmissao}</Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Data Emissão:'}</Typography>
        <Typography variant="body1">
          {moment(certificadoRecebiveis.criteriosRemuneracao.dataEmissao).format('DD/MM/YYYY')}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Data Vencimento:'}</Typography>
        <Typography variant="body1">
          {moment(certificadoRecebiveis.criteriosRemuneracao.dataVencimento).format('DD/MM/YYYY')}
        </Typography>
        <SmSpace />
      </div>
      {certificadoRecebiveis.criteriosRemuneracao.cotacaoInicial && (
        <div>
          <Typography variant="body2">{'Cotação Inicial:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.criteriosRemuneracao.cotacaoInicial}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.criteriosRemuneracao.dataInicioRentabilidade && (
        <div>
          <Typography variant="body2">{'Data Início Rentabilidade:'}</Typography>
          <Typography variant="body1">
            {moment(certificadoRecebiveis.criteriosRemuneracao.dataInicioRentabilidade).format('DD/MM/YYYY')}
          </Typography>
          <SmSpace />
        </div>
      )}

      <div>
        <Typography variant="body2">{'Quando será o início da rentabilidade?'}</Typography>
        <Typography variant="body1">
          {inicioRentabilidadeDescriptions[certificadoRecebiveis.criteriosRemuneracao.inicioRentabilidade]}
        </Typography>
        <SmSpace />
      </div>

      {certificadoRecebiveis.criteriosRemuneracao.dataLimiteIntegralizacao && (
        <div>
          <Typography variant="body2">{'Data Limite de Integralização:'}</Typography>
          <Typography variant="body1">
            {moment(certificadoRecebiveis.criteriosRemuneracao.dataLimiteIntegralizacao).format('DD/MM/YYYY')}
          </Typography>
          <SmSpace />
        </div>
      )}
    </Section>
    <Section title={'Remuneração'} defaultGrid>
      <div>
        <Typography variant="body2">{'Indexador:'}</Typography>
        <Typography variant="body1">
          {indexadorRemuneracaoDescriptions[certificadoRecebiveis.criteriosRemuneracao.indexador]}
        </Typography>
        <SmSpace />
      </div>
      <div>
        <Typography variant="body2">{'Porcentagem Indexador:'}</Typography>
        <Typography variant="body1">
          {certificadoRecebiveis.criteriosRemuneracao.indexadorPorcentagem}
          {' %'}
        </Typography>
        <SmSpace />
      </div>
      {certificadoRecebiveis.criteriosRemuneracao.defasagemFixing && (
        <div>
          <Typography variant="body2">{'Defasagem/Fixing:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.criteriosRemuneracao.defasagemFixing}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.criteriosRemuneracao.periodicidadeCorrecao && (
        <div>
          <Typography variant="body2">{'Periodicidade de Correção:'}</Typography>
          <Typography variant="body1">
            {periodicidadeCorrecaoDescriptions[certificadoRecebiveis.criteriosRemuneracao.periodicidadeCorrecao]}
          </Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.criteriosRemuneracao.proRata && (
        <div>
          <Typography variant="body2">{'Pro-rata:'}</Typography>
          <Typography variant="body1">
            {tipoProRataDescriptions[certificadoRecebiveis.criteriosRemuneracao.proRata]}
          </Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.criteriosRemuneracao.corrigePeriodoFinal && (
        <div>
          <Typography variant="body2">{'Corrige Período Final?'}</Typography>
          <Typography variant="body1">
            {certificadoRecebiveis.criteriosRemuneracao.corrigePeriodoFinal ? 'Sim' : 'Não'}
          </Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.criteriosRemuneracao.diaAniversario && (
        <div>
          <Typography variant="body2">{'Dia de Aniversário:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.criteriosRemuneracao.diaAniversario}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.criteriosRemuneracao.mesAniversario && (
        <div>
          <Typography variant="body2">{'Mês Aniversário:'}</Typography>
          <Typography variant="body1">{certificadoRecebiveis.criteriosRemuneracao.mesAniversario}</Typography>
          <SmSpace />
        </div>
      )}
      {certificadoRecebiveis.criteriosRemuneracao.tipoProjecao && (
        <div>
          <Typography variant="body2">{'Tipo de Projeção:'}</Typography>
          <Typography variant="body1">
            {tipoProjecaoDescriptions[certificadoRecebiveis.criteriosRemuneracao.tipoProjecao]}
          </Typography>
          <SmSpace />
        </div>
      )}
      <div>
        <Typography variant="body2">{'Taxa de Juros Fixo/Spread %:'}</Typography>
        <Typography variant="body1">{certificadoRecebiveis.criteriosRemuneracao.taxaJurosFixoSpread}</Typography>
        <SmSpace />
      </div>
      {certificadoRecebiveis.criteriosRemuneracao.convencaoJurosFixos && (
        <div>
          <Typography variant="body2">{'Covenção:'}</Typography>
          <Typography variant="body1">
            {convencaoJurosFixosDescriptions[certificadoRecebiveis.criteriosRemuneracao.convencaoJurosFixos]}
          </Typography>
          <SmSpace />
        </div>
      )}
    </Section>
    <MultaMoraDetailsSection
      percentualMulta={certificadoRecebiveis.criteriosRemuneracao.percentualMulta}
      periodicidadeMulta={certificadoRecebiveis.criteriosRemuneracao.periodicidadeMulta}
      percentualMora={certificadoRecebiveis.criteriosRemuneracao.percentualMora}
      periodicidadeMora={certificadoRecebiveis.criteriosRemuneracao.periodicidadeMora}
    />
    {(certificadoRecebiveis.custodiantes !== undefined && certificadoRecebiveis.custodiantes?.length > 0  ) && (
      <Section title="Investidores">
        {certificadoRecebiveis.custodiantes?.map((custodiante) => (
          custodiante.investidoresPrivados.map((investidor) => {
            return (
              <React.Fragment key={investidor.investidorId}>
                <Grid container>
                  <Grid item xs={4}>
                    <Typography variant="body2">{'Instituição Custodiante:'}</Typography>
                    <Typography variant="body1">{custodiante.razaoSocialInstituicaoCustodiante}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">{'Investidor:'}</Typography>
                    <Typography variant="body1">{addCpfCnpjMask(investidor.cpfCnpj)}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">{'Quantidade:'}</Typography>
                    <Typography variant="body1">{investidor.quantidade}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">{'Volume Total:'}</Typography>
                    <Typography variant="body1">
                      {(
                        investidor.quantidade * certificadoRecebiveis.criteriosRemuneracao.valorNominalUnitarioEmissao
                      ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">{'Banco:'}</Typography>
                    <Typography variant="body1">{investidor.razaoSocialBanco}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">{'Agência:'}</Typography>
                    <Typography variant="body1">{investidor.agenciaBanco}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body2">{'Conta:'}</Typography>
                    <Typography variant="body1">{investidor.contaBanco}</Typography>
                  </Grid>
                </Grid>
                <SmSpace />
              </React.Fragment>
            )
          })
        ))}
      </Section>
    )}
  </>
);
